import { render, staticRenderFns } from "./GarageManage.vue?vue&type=template&id=0bb9dc33&scoped=true&"
import script from "./GarageManage.vue?vue&type=script&lang=js&"
export * from "./GarageManage.vue?vue&type=script&lang=js&"
import style0 from "./GarageManage.vue?vue&type=style&index=0&id=0bb9dc33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb9dc33",
  null
  
)

export default component.exports